export const environment = {
  production: false,
  apiUrl: "https://ids-sit.myservy.com/api/v1",
};
